import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {ICheeringListItem, ListResponse} from '@/models';

import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {persist} from 'zustand/middleware';

export interface ICheeringStore {
  cheeringList: ICheeringListItem[];
  getAllCheering: (params) => void;
  nbHits: number;
}

export const useCheeringStore = create(
  persist<ICheeringStore>(
    set => ({
      cheeringList: [],
      nbHits: 0,
      getAllCheering: async () => {
        handleApiCallInStore(LoadingKeys.CheeringList, async () => {
          const {data} = await http.get<ListResponse<ICheeringListItem>>(
            API_ENDPOINTS.cheering
          );
          const {items = [], nbHits = 0} = data || {};
          set(() => ({cheeringList: items, nbHits}));
        });
      },
    }),
    {
      name: 'cheering-storage',

    }
  )
);
